import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorDerivatves = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M2.25 5.5A2.25 2.25 0 0 1 4.5 3.25h15a2.25 2.25 0 0 1 2.25 2.25v13a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-13Zm2.25-.75a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-13a.75.75 0 0 0-.75-.75h-15Z"
    />
    <path
      fill="#F7A600"
      d="M14.5 6h1v2h1v6h-1v2h-1v-2h-1V8h1V6Zm-6 2h1v2h1v6h-1v2h-1v-2h-1v-6h1V8Z"
    />
  </svg>
);
export default SvgTwoColorDerivatves;
